import React from 'react';
import PropTypes from 'prop-types';
import classes from './LogoSection.module.scss';

const LogoSection = (props) => {
    const { logo_block } = props?.data || {};

    if (!logo_block?.visible) return null;
    if (logo_block?.images?.length === 0) return null;

    let PositionClass = classes.Center;
    if (logo_block?.position === 'left') {
        PositionClass = classes.Left;
    } else if (logo_block?.position === 'right') {
        PositionClass = classes.Right;
    }

    return (
        <div className={`row ${classes.LogoSection} ${PositionClass}`}>
            {logo_block?.images?.map((imgUrl, index) => {
                return (
                    <div key={`logo-block-logo-${index}`} className='col-lg-4 col-md-4'>
                        <img src={imgUrl} 
                            className={classes.Logo} 
                            alt="logo" />
                    </div>
                )
            })}
        </div>
    )
}

LogoSection.propTypes = {}

export default LogoSection;